import React from 'react';
import PropTypes from "prop-types";

import Polyline from "../Polyline";
import VehicleMarker from "../VehicleMarker";

import defaultCarLogo from './car.svg';

const routePropType = PropTypes.shape({
  dynamic: PropTypes.shape({
    visibility: PropTypes.bool,
    polylines: PropTypes.arrayOf(PropTypes.string),
  }),
  static: PropTypes.shape({
    visibility: PropTypes.bool,
    polylines: PropTypes.arrayOf(PropTypes.string),
  }),
});

export default class LiveTrackingContainer extends React.Component {
  static propTypes = {
    serviceType: PropTypes.string.isRequired,
    countryCode: PropTypes.string,
    driverLocation: PropTypes.shape({
      latitude: PropTypes.number,
      longitude: PropTypes.number,
    }),
    route: routePropType,
    snappedSegment: PropTypes.arrayOf(PropTypes.shape({
      latitude: PropTypes.number,
      longitude: PropTypes.number,
    })),
    bookingType: PropTypes.string,
    isGoSendPartnerOrder: PropTypes.bool,
    driverMarkerIcon: PropTypes.string,
  };

  driverMarkerIcon() {
    return this.props.driverMarkerIcon || defaultCarLogo;
  }

  driverMarker() {
    if (this.props.driverLocation) {
      return (
        <VehicleMarker latitude={this.props.driverLocation.latitude} longitude={this.props.driverLocation.longitude} iconURL={this.driverMarkerIcon()}/>
      );
    }
    return null;
  };

  render() {
    const driverMarker = this.driverMarker();
    return (
      <div>
        {this.props.route && this.props.route.dynamic.polylines.length > 0 &&
          <Polyline driverLocation={this.props.driverLocation} route={this.props.route} snappedSegment={this.props.snappedSegment} />
        }
        {driverMarker}
      </div>
    );
  }
}
